import { Bot, MessageCircle, Phone, type LucideIcon } from "lucide-react";

// The channel a thread came from. Backend `source` values: app, widget, voice,
// phone. Every row gets an icon: robot for website (widget), phone for calls,
// chat bubble for the caller's own app/voice chats.
export function threadChannelIcon(source: string | undefined): {
  Icon: LucideIcon;
  labelKey: string;
} {
  switch (source) {
    case "widget":
      return { Icon: Bot, labelKey: "threads_source_website" };
    case "phone":
      return { Icon: Phone, labelKey: "threads_source_phone" };
    default:
      return { Icon: MessageCircle, labelKey: "threads_source_chat" };
  }
}

// A thread is read-only to the current staff viewer when it belongs to an
// external channel (website/phone) — those are owned by the visitor/caller and
// the backend blocks non-owner posting.
export function isReadOnlyChannel(source: string | undefined): boolean {
  return source === "widget" || source === "phone";
}
